export default __webpack_public_path__ + "static/media/warning--occupied-lanes--g1.a3fb4526.png";